import { useState } from "react";
import DynamicForm, { OnFormSubmitFunc, TDynamicForm } from "../../form-elements/dynamic-form/dynamic-form";
import FormBlockWrapper from "./forms-block-wrapper";
import { TAlertSummary } from "../../elements/alert-summary/alert-summary";
import {
  TPostEdiInvoicServiceNowParams,
  usePostEdiInvoiceServiceNow,
} from "../../../react-query-queries/customer-service/use-post-customer-service-service-now";
import { FieldValues } from "react-hook-form";

export const EDIFakturaForm = {
  mode: "onSubmit",
  reValidateMode: "onChange",
  fields: [
    {
      type: "content",
      name: "edi-content",
      value: <h2 className={"h4"}>Anmäl EDI-faktura</h2>,
    },
    {
      type: "text",
      name: "orgno",
      label: "Organisationsnummer*",
      helperText: "Tio siffror utan bindestreck",
      rules: { required: true },
    },
    {
      type: "text",
      name: "customerNumber",
      label: "Kundnummer",
    },
    {
      type: "text",
      name: "efakturaGlnOrg",
      label: "E-faktura adress, GLN eller org.nummer*",
      rules: { required: true },
    },
    {
      type: "text",
      name: "operator",
      label: "Operatör",
    },
    {
      type: "content",
      name: "contact-heading",
      value: <h2 className={"h4"}>Kontaktuppgifter</h2>,
    },
    {
      type: "text",
      name: "firstName",
      label: "Förnamn",
      autoComplete: "given-name",
      rules: { required: true },
    },
    {
      type: "text",
      name: "lastName",
      label: "Efternamn",
      autoComplete: "family-name",
      rules: { required: true },
    },
    {
      type: "text",
      name: "email",
      label: "E-post*",
      autoComplete: "email",
      rules: { required: true },
    },
    {
      type: "text",
      name: "phone",
      label: "Telefonnummer eller mobil",
      autoComplete: "tel",
    },
  ],
} satisfies TDynamicForm;

type TEDIInvoiceBlockProps = {
  title: string;
  preamble?: React.ReactNode;
};

const EDIInvoiceBlock = ({ title, preamble }: TEDIInvoiceBlockProps) => {
  const [formStatus, setFormStatus] = useState<TAlertSummary>();
  const { isPending, mutateAsync: postForm } = usePostEdiInvoiceServiceNow();

  const onPostForm: OnFormSubmitFunc = (formValues: FieldValues, { reset }) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { terms, ...formValuesWithoutTerms } = formValues;
    const request = {
      ...formValuesWithoutTerms,
      requestType: "Edi-Invoice",
    } satisfies TPostEdiInvoicServiceNowParams;
    postForm(request)
      .then(() => {
        setFormStatus({
          type: "success",
          heading: "Ditt ärende är skickat",
          messages: [
            {
              text: "Ditt supportärende är nu registrerat hos oss. Vi arbetar med att hantera alla inkommande ärenden och kommer att kontakta dig inom kort för att hjälpa dig vidare.",
            },
          ],
        });
        reset();
      })
      .catch((error) => {
        setFormStatus({
          type: "error",
          heading: "Problem med bakomliggande system",
          messages: [
            {
              text: "Det gick tyvärr inte att skicka in ditt ärende. Om det fortsatt inte går kontakta kundservice@preem.se.",
            },
          ],
        });
        console.error(error);
      });
  };

  return (
    <FormBlockWrapper>
      <div className={"text-max-width"}>
        <h3>{title}</h3>
        {preamble && <div>{preamble}</div>}
      </div>
      <div className={"form-max-width"}>
        <DynamicForm
          key={isPending ? "is-pending" : "default"}
          form={EDIFakturaForm}
          onFormSubmit={onPostForm}
          isPostingForm={isPending}
          formStatus={formStatus}
        />
      </div>
    </FormBlockWrapper>
  );
};

export default EDIInvoiceBlock;
